/* jshint ignore:start */

import React from "react";

const Card = (props) => {
  return (
    <div className="col-sm-3" style={{ marginTop: "10px" }}>
      <div className="card img-fluid">{props.children}</div>
    </div>
  );
};

export default Card;
